import { metaAccount } from '@/router/meta-config'
const permissionKey = 'PLACECATEGORY'

export default [
  // places
  {
    path: '/places-categories',
    name: 'page-places-categories',
    component: () => import('@/pages/placesCategories'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/place-category/new',
    name: 'page-place-category-new',
    component: () => import('@/pages/placeCategory'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/place-category/:id',
    name: 'page-place-category',
    component: () => import('@/pages/placeCategory'),
    props: (route) => ({ id: route.params.id }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
